import { PRODUCT_GROUP_TYPE, PRODUCT_TYPES, PRODUCT_CATEGORY } from '@schuettflix/interfaces';
import { getCompatibleProductTypes, getProductCategoryByProductType } from '@schuettflix/product-group-utils';
import { Position, ProductCategoryIcon } from '../types/prefill-template-data';
import { PRODUCT_NAME_LABEL } from '@/phrase/ProductNameLabels.ts';

function getProductCategoryIconName(productCategory: PRODUCT_CATEGORY): ProductCategoryIcon {
    switch (productCategory) {
        case 'TRANSPORT':
            return 'transport';
        case 'MATERIAL':
            return 'material';
        case 'MATERIAL_SERVICE':
        case 'TRANSPORT_SERVICE':
            return 'service';
    }
}

/** @deprecated */
export function getCompatibleProducts(
    productGroupType: PRODUCT_GROUP_TYPE,
    preselectedProductTypes: PRODUCT_TYPES[]
): Position[] {
    const { compatibleProductTypes } = getCompatibleProductTypes({
        selectedProductGroupType: productGroupType,
        selectedProductTypes: preselectedProductTypes,
    });
    return compatibleProductTypes.map(productType => {
        const category = getProductCategoryByProductType(productType);
        return {
            productName: PRODUCT_NAME_LABEL[productType],
            product: {
                type: productType,
                category,
            },
            icon: getProductCategoryIconName(category),
        };
    });
}
